export default "__VITE_ASSET__DlPUdoxA__"